import React, { useState } from 'react';
import { Modal, Button, Form, Card, Row, Col } from 'react-bootstrap';
import { VotoCandidato } from '../../model/banca/votacao/Voto';
import './VotacaoModal.css';

interface VotacaoModalProps {
  show: boolean;
  onHide: () => void;
  onConfirmar: (resultado: VotoCandidato, justificativa: string) => void;
  votarEnabled: boolean;
  setVotarEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  isFacial?: boolean;
}

const VotacaoModal: React.FC<VotacaoModalProps> = ({ show, onHide, onConfirmar, isFacial = false }) => {
  const [votoResultado, setVotoResultado] = useState<VotoCandidato | null>(null);
  const [justificativa, setJustificativa] = useState<string>('');
  const resultadoNegativo = isFacial ? VotoCandidato.INCONCLUSIVO : VotoCandidato.NAO_VALIDADO;
  const labelNegativo = isFacial ? 'Inconclusivo' : 'Não Validado';
  const classeNegativo = isFacial ? 'bg-warning text-dark' : 'bg-danger text-white';
  const exigeJustificativa = votoResultado === VotoCandidato.NAO_VALIDADO || votoResultado === VotoCandidato.INCONCLUSIVO;

  const handleConfirmarVoto = () => {
    if (exigeJustificativa && !justificativa.trim()) {
      return;
    }
    onConfirmar(votoResultado!, justificativa);
    setJustificativa('');
  };

  const handleCardClick = (resultado: VotoCandidato) => {
    setVotoResultado(resultado);
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="votacao-modal-dialog">
      <Modal.Header closeButton className="votacao-modal-header">
        <Modal.Title className="votacao-modal-title">Heteroidentificação - Voto</Modal.Title>
      </Modal.Header>
      <Modal.Body className="votacao-modal-body">
        <Form>
          <Form.Group controlId="votoResultado">
            <div className="votacao-modal-subtitle">Selecione o resultado desta votação</div>
            <Row className="g-3">
              <Col md={6}>
                <Card
                  className={`h-100 votacao-option-card votacao-option-validado ${votoResultado === VotoCandidato.VALIDADO ? 'is-selected' : ''}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleCardClick(VotoCandidato.VALIDADO)}
                >
                  <Card.Body className="text-center">
                    <h5 className="mb-0">✓ Validado</h5>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card
                  className={`h-100 votacao-option-card ${isFacial ? 'votacao-option-inconclusivo' : 'votacao-option-nao-validado'} ${votoResultado === resultadoNegativo ? 'is-selected' : ''}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleCardClick(resultadoNegativo)}
                >
                  <Card.Body className={`text-center ${classeNegativo}`}>
                    <h5 className="mb-0">✗ {labelNegativo}</h5>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form.Group>

          {exigeJustificativa && (
            <Form.Group controlId="justificativa" className="mt-3 votacao-justificativa-group">
              <Form.Label className="votacao-justificativa-label">Justificativa:</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={justificativa}
                onChange={(e) => setJustificativa(e.target.value)}
                required
                className="votacao-justificativa-input"
              />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer className="votacao-modal-footer">
        <Button variant="outline-secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="success"
          onClick={handleConfirmarVoto}
          disabled={!votoResultado || (exigeJustificativa && !justificativa.trim())}
        >
          Confirmar Voto
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VotacaoModal;
